import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { SalesContact } from '../../atlas_sdk/api';
import { AtlasApiService } from '../../atlas_sdk/atlas.api.service';
import { BusinessNavConfigService } from '../../config.service';
import { ModalComponent } from '../../core-components/modal/modal.component';
import { SnackbarService } from '../../core-components/snackbar/snackbar.service';
import { BusinessNavDataService } from '../../data.service';
import { AtlasTranslateService } from '../../translate/translate.service';
import { BusinessApiService } from '../../sales_sdk/business.api.service';

@Component({
  selector: 'atlas-change-subscription-modal',
  templateUrl: './change-subscription.modal.component.html',
  styleUrls: ['./change-subscription.modal.component.scss']
})
export class ChangeSubscriptionModalComponent {
  public headerText$: Observable<string>;
  public prescriptionText$: Observable<string>;
  public descriptionText$: Observable<string>;
  public phoneNumberLabel$: Observable<string>;
  public nameLabel$: Observable<string>;
  public cancelText$: Observable<string>;
  public submitText$: Observable<string>;
  public name: string;
  public phoneNumber: string;
  public messageTxt: string;
  public sendingMessage: boolean;
  @ViewChild('modal', { static: true }) modal: ModalComponent;

  constructor(private viewContainerRef: ViewContainerRef,
              private t: AtlasTranslateService, private apiService: BusinessApiService,
              private configService: BusinessNavConfigService, private snackbarService: SnackbarService) {
    this.headerText$ = this.t.stream('REQUEST_SUBSCRIPTION_CHANGE_MODAL.CHANGE_SUBSCRIPTION', 'Change Subscription');
    this.prescriptionText$ = this.t.stream('REQUEST_SUBSCRIPTION_CHANGE_MODAL.MESSAGE', 'Message');
    this.phoneNumberLabel$ = this.t.stream('REQUEST_SUBSCRIPTION_CHANGE_MODAL.PHONE_NUMBER', 'Phone Number');
    this.nameLabel$ = this.t.stream('REQUEST_SUBSCRIPTION_CHANGE_MODAL.NAME', 'Name');
    this.t.stream('REQUEST_SUBSCRIPTION_CHANGE_MODAL.PLACEHOLDER_MESSAGE', 'I would like to change my subscription.').pipe(
        take(1)
    ).subscribe(t => this.messageTxt = t);
    this.cancelText$ = this.t.stream('COMMON.ACTION_LABELS.CANCEL', 'Cancel');
    this.submitText$ = this.t.stream('COMMON.ACTION_LABELS.SEND', 'Send');
    this.descriptionText$ = this.t.stream('REQUEST_SUBSCRIPTION_CHANGE_MODAL.DESCRIPTION', 'If you would like to change your subscription, please send us a message.');
  }

  closeModal(): void {
    this.modal.closeModal();
  }

  sendMessage(): void {
    if (this.sendingMessage) {
      return;
    }
    this.sendingMessage = true;
    this.configService.accountGroupId$.pipe(
      switchMap((accountGroupId: string) => this.apiService.requestSubscriptionChange({
        businessId: accountGroupId,
        name: this.name,
        phoneNumber: this.phoneNumber,
        message: this.messageTxt
      })),
      take(1),
    ).subscribe(
      () => {
        this.snackbarService.show(this.t.instant('COMMON.RESULT.SUCCESS', 'Success'), 'OK');
        this.sendingMessage = false;
        this.closeModal();
      },
      () => {
        this.snackbarService.show(this.t.instant('COMMON.RESULT.FAILURE', 'Could not send message'), 'OK', {duration: 4000});
        this.sendingMessage = false;
      }
    );
  }
}
